import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import { Modal, Descriptions, Slider, Row, Col, Divider, Input, Checkbox, Radio } from 'antd'
import {withTranslation} from 'react-i18next'
import { CaretRightOutlined, PauseOutlined, HistoryOutlined } from '@ant-design/icons'

@inject('intelligentOutboundCallDetailsStore')
@observer
class FormModal extends Component {
  state = {
    isPlaying: false,
    currentTime: 0,
    duration: 0,
  }

  audioRef = React.createRef()

  componentDidMount() {
  }

  handlePlayPause = () => {
    const { intelligentOutboundCallDetailsStore } = this.props
    const { detailsObj } = intelligentOutboundCallDetailsStore
    const { isPlaying } = this.state
    const audio = this.audioRef.current
    
    if (!audio || !detailsObj?.obsUrl) return

    if (isPlaying) {
      audio.pause()
    } else {
      audio.play().catch(err => {
        console.error('Audio play error:', err)
        this.setState({ isPlaying: false })
      })
    }
    
    this.setState({ isPlaying: !isPlaying })
  }

  handleTimeUpdate = () => {
    const audio = this.audioRef.current
    if (audio) {
      this.setState({
        currentTime: audio.currentTime,
        duration: audio.duration && !isNaN(audio.duration) ? audio.duration : 0
      })
    }
  }

  handleSliderChange = (value) => {
    const audio = this.audioRef.current
    if (audio) {
      audio.currentTime = value
      this.setState({ currentTime: value })
    }
  }

  handleAudioEnded = () => {
    this.setState({
      isPlaying: false,
      currentTime: 0
    })
  }

  handleLoadedMetadata = () => {
    const audio = this.audioRef.current
    if (audio) {
      this.setState({
        duration: audio.duration && !isNaN(audio.duration) ? audio.duration : 0
      })
    }
  }

  formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '00:00'
    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }

  render() {
    const { intelligentOutboundCallDetailsStore, addModalVisible, handleCancel, t } = this.props
    const { detailsObj } = intelligentOutboundCallDetailsStore
    const { isPlaying, currentTime, duration } = this.state

    return (
      <>
        <Modal
          title={t(`outboundCall.viewDetails`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'35%'}
          centered
          footer={null}
          bodyStyle={{ padding: '24px 32px' }}
        >
          <Descriptions column={1} className='call-details'>
            <Descriptions.Item 
              label={t(`outboundCall.callNumber`)}
              labelStyle={{ fontSize: '16px' }}
              contentStyle={{ fontWeight: 'bold', fontSize: '16px' }}
            >
              {detailsObj?.calleeNo}
            </Descriptions.Item>
            {detailsObj?.obsUrl && <Descriptions.Item 
              label={t(`outboundCall.dialogueRecording`)}
              labelStyle={{ fontSize: '16px' }}
            >
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '12px',
                background: '#f0f5ff',
                padding: '0 16px',
                borderRadius: '4px',
                width: '100%',
                height: '100%',
              }}>
                <div>
                  <span style={{ 
                    fontSize: '14px', 
                    color: '#1890ff',
                  }}>{this.formatTime(currentTime)}</span> / <span style={{ 
                    fontSize: '14px', 
                    color: '#000',
                  }}>{this.formatTime(duration)}</span>
                </div>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', margin: '0 8px' }}>
                  <Slider
                    value={currentTime}
                    max={duration || 1}
                    onChange={this.handleSliderChange}
                    style={{ width: '100%', margin: 0 }}
                    disabled={!detailsObj?.obsUrl}
                    tooltip={{ open: false }}
                    trackStyle={{ background: '#1890ff' }}
                    handleStyle={{
                      borderColor: '#1890ff',
                      backgroundColor: '#fff',
                      width: '12px',
                      height: '12px',
                      marginTop: '-4px'
                    }}
                    railStyle={{ background: '#d9d9d9' }}
                  />
                </div>
                <div
                  onClick={this.handlePlayPause}
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: detailsObj?.obsUrl ? 'pointer' : 'not-allowed',
                    transition: 'all 0.3s',
                    opacity: detailsObj?.obsUrl ? 1 : 0.5
                  }}
                  className={detailsObj?.obsUrl ? 'hover-scale' : ''}
                >
                  {isPlaying ? (
                    <PauseOutlined style={{ fontSize: '14px', color: '#000' }} />
                  ) : (
                    <CaretRightOutlined style={{ fontSize: '14px', color: '#000', marginLeft: '2px' }} />
                  )}
                </div>
                <audio
                  ref={this.audioRef}
                  src={detailsObj?.obsUrl}
                  onTimeUpdate={this.handleTimeUpdate}
                  onLoadedMetadata={this.handleLoadedMetadata}
                  onEnded={this.handleAudioEnded}
                  onError={(e) => {
                    console.error('Audio error:', e)
                    this.setState({ isPlaying: false })
                  }}
                />
              </div>
            </Descriptions.Item>}
          </Descriptions>
          {detailsObj?.dialogueRecord?.length > 0 && <>
            <Row gutter={[16, 0]}>
              <Col span={24}>
                <div className='leftTit' style={{ marginBottom: 10}}>{t(`outboundCall.dialogueAnalysis`)}</div>
              </Col>
            </Row>
            <div className='dialogueAnalysis'>
              {(detailsObj?.dialogueRecord || []).map((item, index) => (
                <div 
                  key={index} 
                  className='dialogueAnalysis-item'
                  style={{ 
                    flexDirection: item.userType === 'customer' ? 'row' : 'row-reverse',
                  }}
                >
                  {item.userType === 0 ? (
                    <>
                      <div style={{ flex: 1 }}>
                        <div className='dialogueAnalysis-role'>
                          { t(`outboundCall.customer`)}
                          <span className='dialogueAnalysis-time'>
                            {item.recordTime}
                          </span>
                        </div>
                        <div className='dialogueAnalysis-content' style={{ 
                          background: '#52c41a',
                          color: '#fff',
                        }}>
                          {item.message}
                          <div className='dialogueAnalysis-content-arrow'  style={{
                            left: '-8px',
                            borderRight: '8px solid #52c41a'
                          }} />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ flex: 1, textAlign: 'right' }}>
                        <div className='dialogueAnalysis-role'>
                          <span className='dialogueAnalysis-time'>
                            {item.recordTime}
                          </span>
                          {t(`outboundCall.robot`)}
                        </div>
                        <div className='dialogueAnalysis-content' style={{ 
                          background: '#faad14',
                          color: '#000',
                          wordBreak: 'break-word',
                          display: 'inline-block'
                        }}>
                          {item.message}
                          <div className='dialogueAnalysis-content-arrow' style={{
                            right: '-8px',
                            borderLeft: '8px solid #faad14'
                          }} />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </>}
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
